import { useKeycloak } from "@react-keycloak/web";
import NoLogin from "../pages/NoLogin";
import { hideCookieButton } from "./utils";
import { useEffect, useState } from "react";
import useAxios from "./useAxios";

const PrivateRoute = ({ children }) => {
    const { keycloak, initialized } = useKeycloak();
    const { fetch: fetchUserDetail, data: userDetailData, error: userDetailError, loaded: userDetailLoaded } = useAxios("", "", {}, true);
    const { fetch: fetchCreateLoginHistory } = useAxios("", "", {}, true);

    const [sessionState, setSessionState] = useState("loading"); // loading, authenticated (pending validation), unauthenticated, valid, invalid

    useEffect(() => {
        if (!initialized) {
            if (sessionStorage.getItem('isValid') === 'false') {
                setSessionState("invalid");
                return;
            }
            setSessionState("loading");
            return;
        }

        if (!keycloak.authenticated) {
            if (sessionStorage.getItem('isValid') === 'false') {
                setSessionState("invalid");
                return;
            }
            setSessionState("unauthenticated");
            return;
        }

        if (sessionStorage.getItem('isValid') === 'true') {
            setSessionState("valid");
            return;
        }

        setSessionState("authenticated");
    }, [initialized, keycloak.authenticated]);

    useEffect(() => {
        if (sessionState !== "authenticated") return;
        if (sessionStorage.getItem('isValid') === 'true') return;
        
        fetchUserDetail("POST", "/User/user-detail", {
            nif: keycloak.tokenParsed?.preferred_username ?? 0,
            email: keycloak.tokenParsed?.email ?? ""
        });
    }, [
        sessionState,
        keycloak.tokenParsed?.preferred_username,
        keycloak.tokenParsed?.email,
    ]);

    // Process validation result
    useEffect(() => {
        if (!userDetailLoaded) return;

        if (userDetailError && userDetailError.length > 0) {
            setSessionState("unauthenticated");
            sessionStorage.removeItem('isValid');
            sessionStorage.removeItem('CreateLoginHistory');
            sessionStorage.removeItem('company');
            sessionStorage.removeItem('nifCompany');
            sessionStorage.removeItem('ADM');
            keycloak.logout();
            return;
        }

        if (userDetailData && userDetailData.nif) {
            setSessionState("valid");
            sessionStorage.setItem('isValid', 'true');
            sessionStorage.setItem('company', userDetailData.companyName ?? '');
            sessionStorage.setItem('nifCompany', userDetailData.companyNif ?? '');
            sessionStorage.setItem('ADM', String(userDetailData.isAdmin ?? false));

            if (sessionStorage.getItem('CreateLoginHistory') !== 'logged') {
                fetchCreateLoginHistory("POST", "/User/create-login-history", { nif: keycloak.tokenParsed?.preferred_username });
                sessionStorage.setItem('CreateLoginHistory', 'logged');
            }
        } else {
            setSessionState("invalid");
            sessionStorage.setItem('isValid', 'false');
            sessionStorage.removeItem('CreateLoginHistory');
            sessionStorage.removeItem('company');
            sessionStorage.removeItem('nifCompany');
            sessionStorage.removeItem('ADM');
            keycloak.logout();
        }
    }, [userDetailData, userDetailLoaded, userDetailError, keycloak, fetchCreateLoginHistory]);

    if (sessionState === "loading" || sessionState === "authenticated") {
        return (
            <div className="d-flex justify-content-center align-items-center mt-5">
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        );
    }

    if (sessionState === "invalid") {
        return <NoLogin showInvalid={true} />;
    }

    if (sessionState === "unauthenticated") {
        return <NoLogin showInvalid={false} />;
    }

    if (sessionState === "valid") {
        hideCookieButton();
        return children;
    }
};

export default PrivateRoute;
